import React from "react";
import { useState } from "react";

import { useParams } from "react-router-dom";

import Typography from "@mui/material/Typography";

import axios from "axios";

import Button from "@mui/material/Button";
import LoadingButton from "@mui/lab/LoadingButton";
import { Helmet } from "react-helmet";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import MarkEmailUnreadOutlinedIcon from "@mui/icons-material/MarkEmailUnreadOutlined";
import CancelScheduleSendOutlinedIcon from "@mui/icons-material/CancelScheduleSendOutlined";

import { useNavigate } from "react-router-dom";

import PagePaper from "../PageComponents/PagePaper";
import Page from "../PageComponents/Page";

import GetCSRFToken from "./GetCSRFToken";

function UnsubscribeEmailPage() {
  const { uidb64, token } = useParams<{ uidb64: string; token: string }>();

  const [nextAction, setNextAction] = useState<"unsubscribe" | "resubscribe">("unsubscribe");

  const [loading, setLoading] = useState(false);
  const [generalError, setGeneralError] = useState<string | undefined>(undefined);

  const navigate = useNavigate();

  function handleSubmit() {
    const postParams = { uidb64: uidb64, token: token };
    const postUrl = nextAction === "unsubscribe" ? "/api/user/email/unsubscribe" : "/api/user/email/subscribe";
    setLoading(true);
    axios
      .post(postUrl, postParams, {
        headers: { "X-CSRFToken": GetCSRFToken() },
      })
      .then((res) => {
        setNextAction(nextAction === "unsubscribe" ? "resubscribe" : "unsubscribe");
        setGeneralError(undefined);
      })
      .catch((err) => {
        [
          {
            key: "general",
            fn: setGeneralError,
          },
        ].map((error_details_handlers) => error_details_handlers.fn(err.response.data[error_details_handlers.key]));
      })
      .finally(() => setLoading(false));
  }

  return (
    <Page pageLoading={false}>
      <Helmet>
        <title>Salus | Unsubscribe</title>
      </Helmet>
      <PagePaper title="Email Notifications">
        {generalError === undefined ? (
          <Typography variant="body1">
            Click below to{nextAction === "unsubscribe" ? " unsubscribe from " : " resubscribe to "}all email
            notifications.
          </Typography>
        ) : (
          <Typography color="error" variant="body1">
            {generalError}
          </Typography>
        )}

        <LoadingButton
          variant={nextAction === "unsubscribe" ? "text" : "contained"}
          size="large"
          color={nextAction === "unsubscribe" ? undefined : undefined}
          endIcon={nextAction === "unsubscribe" ? <CancelScheduleSendOutlinedIcon /> : <MarkEmailUnreadOutlinedIcon />}
          loading={loading}
          onClick={() => {
            if (!loading) {
              handleSubmit();
            }
          }}
          disabled={generalError !== undefined}
          sx={{ whiteSpace: "nowrap" }}
        >
          {nextAction === "unsubscribe" ? "Unsubscribe from emails" : "Subscribe to emails"}
        </LoadingButton>
      </PagePaper>

      <Button
        variant={nextAction === "unsubscribe" ? "contained" : "text"}
        startIcon={<ArrowBackIcon />}
        onClick={() => navigate("/")}
      >
        Back to Salus
      </Button>
    </Page>
  );
}

export default UnsubscribeEmailPage;
